import { Field } from "formik";
import React, { type FC, type ReactNode } from "react";

import { FormInputLayout } from "./form_input_layout";

interface SelectFieldOption {
  value: string | number;
  name: string;
}

type SelectFieldProps = Omit<
  React.ComponentPropsWithoutRef<"input"> & {
    options: SelectFieldOption[];
    helpElement?: ReactNode;
    label: string;
    name: string;
  },
  "type"
>;

const Option = ({ value, name }: SelectFieldOption) => (
  <option key={value} value={value}>
    {name}
  </option>
);

const SelectField: FC<SelectFieldProps> = ({
  helpElement,
  id,
  label,
  name,
  options,
  ...rest
}) => {
  const fieldElement = (
    <Field as="select" id={id ?? name} name={name} {...rest}>
      {(options || []).map((option) => (
        <Option key={option.name} {...option} />
      ))}
    </Field>
  );

  const props = {
    label,
    name,
    helpElement,
    fieldElement,
  };
  return <FormInputLayout {...props}></FormInputLayout>;
};

export { SelectField, type SelectFieldOption };
